export default {"src":"/_next/static/media/KVUE.755a35e3.svg","height":18,"width":18};